import { render, staticRenderFns } from "./CompareGallery.vue?vue&type=template&id=6cff0410&scoped=true&"
import script from "./CompareGallery.vue?vue&type=script&lang=ts&"
export * from "./CompareGallery.vue?vue&type=script&lang=ts&"
import style0 from "./CompareGallery.vue?vue&type=style&index=0&id=6cff0410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff0410",
  null
  
)

export default component.exports